import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import {
  getArmyPickerArmies,
  getGameSystems
} from "../../components/api/APIUtilities";
import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Link,
  TextField,
  Typography
} from "@mui/material";

import { postNotification } from "../../components/utilities/Notifications";

import DatePickerComponent from "../../components/utilities/DatePickerComponent";
import moment from "moment";

import GameSystemPicker from "../../components/utilities/gamesystempickers/GameSystemPicker";

import { Formik } from "formik";
import * as Yup from "yup";

import GenericPicker from "../../components/utilities/GenericPicker";
import GoogleAddressSearch from "../../components/utilities/GoogleAddressSearch";
import ListResponsive from "../../components/other/ListResponsive";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { globalVariables } from "../../global/GlobalVariables";
import ArmyPicker from "../../components/utilities/ArmyPicker";
import { BCPSearch, BCPShareNodes } from "../../components/icons/bcp/BCPIcons";
import {
  findGetParameter,
  getData
} from "../../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { useNavigate } from "react-router";
import ShareModal from "../../components/modals/ShareModal";
import { isAppMode } from "../../global/AppOverlay";
import { urlToString, stringToUrl } from "../events/utils/event";
import {
  getLocalStorage,
  setLocalStorage
} from "../../components/layout/cookies/CookieFunctions";
import { useTranslation } from "react-i18next";

export default function ArmyListSearchOld() {
  const authContext = useContext(AuthContext);
  const globalVars = globalVariables();
  const appMode = isAppMode();
  const navigate = useNavigate();

  const { t } = useTranslation("translation", {
    keyPrefix: "components.ArmyListSearchOld"
  });

  const searchParam = findGetParameter("search");

  const searchParams = {
    startDate: findGetParameter("startDate"),
    endDate: findGetParameter("endDate"),
    gameType: findGetParameter("gameType"),
    eventSubType: findGetParameter("eventSubType"),
    armyId: findGetParameter("armyId"),
    subFactionId: findGetParameter("subFactionId"),
    location: {
      name: findGetParameter("locationName"),
      lat: findGetParameter("lat"),
      long: findGetParameter("long"),
      distance: findGetParameter("distance")
    },
    limit: 100,
    eventLists: true
  };

  const [searchReady, setSearchReady] = useState(false);
  const [showSearch, setShowSearch] = useState(
    searchParam === "true" ? false : true
  );
  const [searchValues, setSearchValues] = useState({
    startDate:
      searchParams?.startDate && searchParams?.startDate !== null
        ? moment(searchParams.startDate).format("YYYY-MM-DD")
        : moment().subtract(7, "days").format("YYYY-MM-DD"),
    endDate:
      searchParams?.endDate && searchParams?.endDate !== null
        ? moment(searchParams.endDate).format("YYYY-MM-DD")
        : moment().add(2, "months").endOf("month").format("YYYY-MM-DD"),
    gameType:
      searchParams?.gameType && searchParams?.gameType !== null
        ? searchParams.gameType
        : "",
    eventSubType:
      searchParams?.eventSubType && searchParams?.eventSubType !== null
        ? searchParams.eventSubType
        : "",
    location:
      searchParams?.location?.lat &&
      searchParams?.location?.long &&
      searchParams?.location?.name
        ? urlToString(searchParams.location.name)
        : searchParams?.location?.lat &&
            searchParams?.location?.long &&
            !searchParams?.location?.name
          ? "Shared Location"
          : "Global",
    lat: searchParams?.location?.lat || null,
    long: searchParams?.location?.long || null,
    locationName: searchParams?.location?.name
      ? urlToString(searchParams.location.name)
      : null,
    selectedAddress: "",
    selectedLocation: null,
    distance: searchParams?.location?.distance || 50,
    armyId:
      searchParams?.armyId && searchParams?.armyId !== null
        ? searchParams.armyId
        : "",
    subFactionId:
      searchParams?.subFactionId && searchParams?.subFactionId !== null
        ? searchParams.subFactionId
        : ""
  });

  const [geoLocation, setGeoLocation] = useState(null);
  const [locationOpen, setLocationOpen] = useState(false);

  var initalGameSystems = [];
  if (authContext?.authState?.cookieConsent) {
    var getGetCachedData = getLocalStorage(`gameSystems`);
    if (getGetCachedData) {
      initalGameSystems = JSON.parse(getGetCachedData);
    }
  }
  const [gameSystem, setGameSystem] = useState(null);
  const [gameSystems, setGameSystems] = useState(initalGameSystems);

  const [armies, setArmies] = useState(null);
  const [armyDict, setArmyDict] = useState({});

  const [armyLists, setArmyLists] = useState([]);
  const [isSearching, setIsSearching] = useState(searchParam ? true : null);

  const [nextKey, setNextKey] = useState(null);
  const [hasMore, setHasMore] = useState(true);

  const [savedFilters, setSavedFilters] = useState(null);

  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [shareSearchPath, setShareSearchPath] = useState(null);

  const search = async (values) => {
    var filters = {
      limit: 100,
      eventLists: true,
      startDate: searchParams?.startDate
        ? moment(searchParams.startDate).utc().format("YYYY-MM-DD HH:mm")
        : moment(values?.startDate, "YYYY-MM-DD HH:mm").utc().format(),
      endDate: searchParams?.endDate
        ? moment(searchParams.endDate).utc().format("YYYY-MM-DD HH:mm")
        : moment(values?.endDate, "YYYY-MM-DD HH:mm").utc().format(),
      "expand[]": ["player", "event", "character"]
    };

    // Filters section
    let location;
    if (moment(filters?.startDate).isAfter(moment(filters?.endDate))) {
      throw new Error("Start Date must be before the End Date");
    }
    if (values?.gameType && values?.gameType !== "") {
      filters.gameType = values.gameType;
    } else if (searchParams?.gameType && searchParams?.gameType !== "") {
      filters.gameType = searchParams?.gameType;
    }
    if (values?.eventSubType && values?.eventSubType !== "") {
      filters.eventSubType = values.eventSubType;
    }
    if (values?.armyId && values?.armyId !== "") {
      filters.armyId = values.armyId;
    } else if (searchParams?.armyId && searchParams?.armyId !== "") {
      filters.armyId = searchParams?.armyId;
    }

    if (values?.subFactionId && values?.subFactionId !== "") {
      filters.subFactionId = values.subFactionId;
    } else if (
      searchParams?.subFactionId &&
      searchParams?.subFactionId !== ""
    ) {
      filters.subFactionId = searchParams?.subFactionId;
    }

    if (values?.location === "Current Location") {
      location = {
        distance: values.distance,
        center: {
          lat: geoLocation.latitude,
          long: geoLocation.longitude
        }
      };
    } else if (values?.location === "Online Only") {
      filters.onlineOnly = true;
    } else if (
      values?.location !== "Global" &&
      values?.selectedLocation?.coordinate?.length === 2
    ) {
      location = {
        distance: values.distance,
        center: {
          lat: values.selectedLocation.coordinate[1],
          long: values.selectedLocation.coordinate[0]
        }
      };
    } else if (
      values?.location === searchValues?.locationName ||
      values?.location === "Shared Location" ||
      (searchParams?.location?.distance &&
        searchParams?.location?.lat &&
        searchParams?.location?.long)
    ) {
      location = {
        name: searchValues?.locationName || searchParams?.location?.name,
        distance: searchValues?.distance || searchParams?.location?.distance,
        center: {
          lat: searchValues?.lat || searchParams?.location?.lat,
          long: searchValues?.long || searchParams?.location?.long
        }
      };
    }
    if (location) {
      if (values?.selectedAddress) {
        filters.selectedAddress = values.selectedAddress;
      }
      filters.location = JSON.stringify(location);
    }
    if (nextKey) {
      filters.nextKey = nextKey;
    }
    setSavedFilters(filters);

    const apiArmyLists = await getData("/armylists", filters);

    apiArmyLists?.data?.sort(function (a, b) {
      if (a?.event?.id === b?.event?.id) {
        if (a?.player?.numWins === b?.player?.numWins) {
          if (
            a?.player?.battlePoints !== undefined &&
            b?.player?.battlePoints !== undefined
          ) {
            return b.player.battlePoints - a.player.battlePoints;
          } else if (a?.player?.battlePoints !== undefined) {
            return 1;
          } else if (b?.player?.battlePoints !== undefined) {
            return -1;
          }
        } else {
          if (
            a?.player?.numWins !== undefined &&
            b?.player?.numWins !== undefined
          ) {
            return a.player.numWins - b.player.numWins;
          } else if (a?.player?.numWins !== undefined) {
            return 1;
          } else if (b?.player?.numWins !== undefined) {
            return -1;
          }
        }
      } else {
        if (
          moment(a?.event?.eventDate)?.format("YYYY-MM-DD") ===
          moment(b?.event?.eventDate)?.format("YYYY-MM-DD")
        ) {
          var nameA = a?.event?.name?.toLowerCase();
          var nameB = b?.event?.name?.toLowerCase();
          if (nameA > nameB) return 1;
          if (nameA < nameB) return -1;
        }
        return moment(a?.event?.eventDate).diff(moment(b?.event?.eventDate));
      }
      return 0;
    });

    if (apiArmyLists?.nextKey) {
      filters.nextKey = apiArmyLists.nextKey;
    }

    setNextKey(apiArmyLists.nextKey);

    if (savedFilters && apiArmyLists?.data?.length === 0 && armyLists?.length) {
      setHasMore(false);
      setIsSearching(false);
      return;
    } else if (apiArmyLists?.data?.length === 0) {
      setIsSearching(false);
      setShowSearch(true);
      setHasMore(false);
      postNotification("info", "No lists found matching your search criteria.");
      return;
    }

    if (apiArmyLists.lastPage === true && armyLists?.length) {
      setHasMore(false);
      setIsSearching(false);
      return;
    }

    setArmyLists(
      apiArmyLists?.data?.length
        ? [...armyLists, ...apiArmyLists.data]
        : apiArmyLists.data
    );

    if (searchParam) {
      setIsSearching(false);
    }
  };

  // TODO: Location
  useEffect(() => {
    const check = async () => {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(function (position) {
          setGeoLocation(position.coords);
        });
      } else {
        setSearchValues({
          ...searchValues,
          location: "Global"
        });
      }

      setSearchReady(true);

      var data = await getGameSystems();
      setGameSystems(data);
      if (authContext?.authState?.cookieConsent) {
        try {
          setLocalStorage("gameSystems", JSON.stringify(data));
          var getCachedItems = getLocalStorage("CachedItems");
          var cachedItems = getCachedItems ? JSON.parse(getCachedItems) : {};
          cachedItems["gameSystems"] = true;
          setLocalStorage("CachedItems", JSON.stringify(cachedItems));
        } catch (err) {}
      }
    };
    check();
    // eslint-disable-next-line
  }, []);

  // If search url param is true, skip search form and go straight to results based on url params
  useEffect(() => {
    const go = async () => {
      try {
        const filters = searchParams || {};

        // Preps data for API request if not in proper format
        for (const [key, value] of Object.entries(filters)) {
          if (!value) {
            delete filters[key];
          }

          if (typeof filters[key] === "object") {
            if (Object.keys(filters[key]).length) {
              for (const [key2, value] of Object.entries(filters[key])) {
                if (!value) {
                  delete filters[key][key2];
                }
              }
            }
            if (!Object.keys(filters[key]).length) {
              delete filters[key];
            }
          }
        }

        await search(filters);
      } catch (err) {
        postNotification("error", err);
      }
    };

    if (searchParam) {
      go();
    }
    // eslint-disable-next-line
  }, []);

  // Create url path with selected filters
  useEffect(() => {
    let newPath = "";

    if (savedFilters && savedFilters !== undefined) {
      newPath += appMode
        ? `/app/play/list-search?search=true&`
        : `/play/list-search?search=true&`;

      if (savedFilters?.startDate) {
        newPath += `startDate=${moment(savedFilters.startDate)
          .startOf("day")
          .format("YYYY-MM-DD")}&`;
      }

      if (savedFilters?.endDate) {
        newPath += `endDate=${moment(savedFilters.endDate)
          .endOf("day")
          .format("YYYY-MM-DD")}&`;
      }

      if (savedFilters?.gameType) {
        newPath += `gameType=${savedFilters.gameType}&`;
      }

      if (savedFilters?.eventSubType) {
        newPath += `eventSubType=${savedFilters.eventSubType}&`;
      }

      if (savedFilters?.armyId) {
        newPath += `armyId=${savedFilters.armyId}&`;
      }

      if (savedFilters?.subFactionId) {
        newPath += `subFactionid=${savedFilters.subFactionId}&`;
      }

      if (savedFilters?.location) {
        const tempLocation = JSON.parse(savedFilters.location);

        newPath += `distance=${tempLocation.distance}&lat=${tempLocation.center.lat}&long=${tempLocation.center.long}&`;

        if (savedFilters?.selectedAddress) {
          newPath += `locationName=${stringToUrl(
            savedFilters?.selectedAddress
          )}&`;
        }
      }

      // Trims any trailing "&" in url
      if (newPath && newPath !== "") {
        newPath = newPath.substring(0, newPath.length - 1);
      }
    }

    setShareSearchPath(newPath);

    // eslint-disable-next-line
  }, [savedFilters]);
  // }, [])

  // Updates url when switching between search and results
  useEffect(() => {
    if (!showSearch && shareSearchPath) {
      navigate(shareSearchPath, { replace: false });
    } else if (showSearch) {
      navigate(appMode ? `/app/play/list-search` : `/play/list-search`);
    }
    // eslint-disable-next-line
  }, [showSearch]);

  // Sets gamesystems and factions if loading in from shared url
  useEffect(() => {
    if (searchParam && searchParams?.gameType && gameSystems && !gameSystem) {
      for (let gs of gameSystems) {
        if (gs.code === parseInt(searchParams?.gameType)) {
          setGameSystem(gs);
        }
      }
    }

    const go = async () => {
      try {
        if (gameSystem?.hasFactions) {
          const { armyArray, subFactionDict } = await getArmyPickerArmies(
            gameSystem.id
          );

          if (armyArray?.length) {
            setArmies(armyArray);
            setArmyDict(subFactionDict);
          }
        }
      } catch (err) {
        postNotification("error", err);
      }
    };

    go();
    // eslint-disable-next-line
  }, [gameSystem]);

  return (
    <Box sx={{ width: "100%" }}>
      <Container
        sx={{
          pt: 2,
          pb: 2
        }}
        maxWidth="lg"
      >
        <Grid container sx={{ gap: 2 }}>
          <Grid
            item
            xs={12}
            sx={{
              p: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <Typography
              variant="h2"
              component="h3"
              fontWeight="700"
              gutterBottom
            >
              {t("listSearch")}
            </Typography>

            {!showSearch && (
              <IconButton
                size="small"
                color="inherit"
                onClick={() => setShareModalOpen(true)}
              >
                <BCPShareNodes
                  style={{ "font-style": "20px", width: "20px" }}
                />
              </IconButton>
            )}
          </Grid>

          {showSearch && (
            <Grid
              item
              xs={12}
              sx={{
                p: 2,
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
              }}
            >
              <Formik
                initialValues={searchValues}
                enableReinitialize={true}
                validationSchema={Yup.object().shape({
                  gameType: Yup.string().required("Required")
                })}
                onSubmit={async (values, { setSubmitting, setFieldValue }) => {
                  try {
                    setSearchValues(values);
                    setIsSearching(true);
                    await search(values);
                    setShowSearch(false);
                    navigate(
                      appMode ? `/app/play/list-search` : `/play/list-search`
                    );
                  } catch (error) {
                    postNotification("error", error);
                    setIsSearching(false);
                  } finally {
                    setIsSearching(false);
                  }
                }}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  touched,
                  values,
                  setFieldValue
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        xs={12}
                        sm={
                          values.location === "Global" ||
                          values.location === "Online Only"
                            ? 12
                            : 6
                        }
                      >
                        <GenericPicker
                          label={t("location", { keyPrefix: "fields" })}
                          inclAny={false}
                          name="location"
                          list={[
                            <Box sx={{ p: 1 }}>
                              <GoogleAddressSearch
                                setLocationData={(e) => {
                                  setFieldValue(
                                    "selectedAddress",
                                    e?.formatted_address
                                      ? e.formatted_address
                                      : ""
                                  );
                                  setFieldValue(
                                    "location",
                                    e?.formatted_address
                                      ? e.formatted_address
                                      : "Current Location"
                                  );
                                  setFieldValue("selectedLocation", e);
                                  setLocationOpen(false);
                                }}
                              />
                            </Box>,
                            values.selectedAddress !== ""
                              ? values.selectedAddress
                              : null,
                            geoLocation ? "Current Location" : null,
                            "Global",
                            searchValues?.lat &&
                            searchValues?.long &&
                            searchValues?.locationName
                              ? searchValues.locationName
                              : searchValues?.lat &&
                                  searchValues?.long &&
                                  !searchValues?.locationName
                                ? "Shared Location"
                                : null
                          ]}
                          value={values.location}
                          handleChange={handleChange}
                          open={locationOpen}
                          setOpen={setLocationOpen}
                        />
                      </Grid>
                      {values.location !== "Global" &&
                        values.location !== "Online Only" && (
                          <Grid item xs={12} sm={6}>
                            <TextField
                              name="distance"
                              label={t("distanceIn", {
                                keyPrefix: "fields",
                                units: t("miles", { keyPrefix: "misc.units" })
                              })}
                              value={values.distance}
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              error={Boolean(
                                touched.distance && errors.distance
                              )}
                              helperText={touched.distance && errors.distance}
                              type="number"
                              inputProps={{
                                min: 0
                              }}
                            />
                          </Grid>
                        )}
                      <Grid item xs={12} sm={6}>
                        <DatePickerComponent
                          name="startDate"
                          label={t("startDate", { keyPrefix: "fields" })}
                          value={values.startDate}
                          setFieldValue={setFieldValue}
                          error={Boolean(
                            touched.startDate && values.startDate === ""
                          )}
                          helperText={
                            touched.startDate && values.startDate === ""
                              ? t("required", {
                                  keyPrefix: "components.EventPairings"
                                })
                              : null
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <DatePickerComponent
                          name="endDate"
                          label={t("endDate", { keyPrefix: "fields" })}
                          value={values.endDate}
                          setFieldValue={setFieldValue}
                          error={Boolean(
                            touched.endDate && values.endDate === ""
                          )}
                          helperText={
                            touched.endDate && values.endDate === ""
                              ? "Required"
                              : null
                          }
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <GameSystemPicker
                          name="gameType"
                          required
                          value={values.gameType}
                          handleChange={async (e) => {
                            if (e.target.value === values.gameType) {
                              return;
                            }
                            handleChange(e);
                            setFieldValue("armyId", "");
                            setFieldValue("subFactionId", "");
                            var newGameSystem = gameSystems?.filter(
                              (gs) => gs.code === e.target.value
                            )[0];
                            setGameSystem(newGameSystem);

                            setArmies(null);
                            setArmyDict({});
                          }}
                          gameSystems={gameSystems}
                          touched={touched.gameType}
                          error={errors.gameType}
                        />
                      </Grid>
                      {(gameSystem?.hasFactions || searchValues?.armyId) && (
                        <>
                          <Grid item xs={12}>
                            <ArmyPicker
                              armies={armies}
                              name="armyId"
                              label={
                                gameSystem?.factionLabel ||
                                t("faction", { keyPrefix: "misc.pairings" })
                              }
                              value={values.armyId}
                              handleChange={(e) => {
                                handleChange(e);
                                setFieldValue("subFactionId", "");
                              }}
                              error={Boolean(touched.armyId && errors.armyId)}
                              helperText={touched.armyId && errors.armyId}
                              clearable
                            />
                          </Grid>
                          {(gameSystem?.hasSubFactions ||
                            searchParams?.subFactionId) && (
                            <Grid item xs={12}>
                              <GenericPicker
                                name="subFactionId"
                                label={
                                  gameSystem?.subFactionLabel ||
                                  t("subFaction", {
                                    keyPrefix: "misc.pairings"
                                  })
                                }
                                value={values.subFactionId}
                                handleChange={handleChange}
                                inclAny={true}
                                list={armyDict?.[values.armyId] || []}
                                error={Boolean(
                                  touched.subFactionId && errors.subFactionId
                                )}
                                helperText={
                                  touched.subFactionId && errors.subFactionId
                                }
                                disabled={
                                  !values.armyId || values.armyId === ""
                                }
                                clearable
                              />
                            </Grid>
                          )}
                        </>
                      )}
                      {globalVars?.eventSubTypes?.list?.length > 0 && (
                        <Grid item xs={12}>
                          <GenericPicker
                            name="eventSubType"
                            label={
                              globalVars?.eventSubTypes?.label ||
                              t("eventSubType", { keyPrefix: "misc.pairings" })
                            }
                            value={values.eventSubType}
                            handleChange={handleChange}
                            list={globalVars.eventSubTypes.list || []}
                            inclAny={true}
                          />
                        </Grid>
                      )}

                      <Grid item xs={12}>
                        <Button
                          type="submit"
                          color={"primary"}
                          variant={"contained"}
                          fullWidth
                          startIcon={<BCPSearch />}
                        >
                          {t("search", { keyPrefix: "buttons" })}
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </Grid>
          )}
          {isSearching !== null && !showSearch && (
            <Grid
              item
              xs={12}
              sx={{
                p: 2,
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
              }}
            >
              <ListResponsive
                originalList={isSearching ? null : armyLists}
                doSearch
                actionButton={[
                  {
                    props: {
                      variant: "contained",
                      color: "primary",
                      onClick: () => {
                        setArmyLists([]);
                        setShowSearch(true);
                        setNextKey(null);
                        setHasMore(true);
                        // setSavedFilters(null);
                      },
                      startIcon: <BCPSearch />
                    },
                    label: t("editSearch", { keyPrefix: "fields" })
                  }
                ]}
                searchProps={{
                  label: t("searchResults", {
                    keyPrefix: "components.OrganizationSearch"
                  }),
                  performSearch: (originalList, searchText) => {
                    if (!searchText || searchText === "") {
                      return originalList;
                    } else {
                      var filteredList = originalList.filter(function (el) {
                        if (el?.event?.name?.toLowerCase().includes(searchText))
                          return true;
                        if (
                          el?.player?.firstName
                            ?.toLowerCase()
                            .includes(searchText)
                        )
                          return true;
                        if (
                          el?.player?.lastName
                            ?.toLowerCase()
                            .includes(searchText)
                        )
                          return true;
                        if (
                          el?.player?.armyName
                            ?.toLowerCase()
                            .includes(searchText)
                        )
                          return true;
                        if (
                          el?.player?.teamName
                            ?.toLowerCase()
                            .includes(searchText)
                        )
                          return true;
                        return false;
                      });
                      return filteredList;
                    }
                  }
                }}
                rowProps={{
                  mapFunction: (row, index) => (
                    <>
                      {Boolean(
                        index === 0 ||
                          row.eventId !== armyLists[index - 1]?.eventId
                      ) && (
                        <Grid
                          key={index}
                          item
                          xs={12}
                          sx={{
                            p: 1,
                            borderRadius: 1,
                            backgroundColor: "table.headerBackground",
                            color: "table.headerColor"
                          }}
                        >
                          <Link
                            href={`/event/${row.eventId}${
                              !row.event?.hidePlacings
                                ? "?active_tab=placings"
                                : ""
                            }`}
                            target="_blank"
                            underline="none"
                            color="inherit"
                          >
                            <Grid container>
                              <Grid item xs={12}>
                                <Typography variant="body1">
                                  {row.event?.name}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  paragraph
                                  sx={{ mb: 0 }}
                                >
                                  {moment(row?.event?.eventDate).format("LL")}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Link>
                        </Grid>
                      )}
                      <Grid
                        key={index}
                        item
                        xs={12}
                        sx={{
                          p: 1,
                          borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
                        }}
                      >
                        <Link
                          href={
                            row?.armyListSolforge?.id
                              ? `${
                                  getEnvironmentVariable(
                                    "HEADER_SOLFORGE_URL"
                                  ) || ""
                                }/fused/${row.armyListSolforge.id}`
                              : `/list/${row.id}`
                          }
                          target="_blank"
                          underline="none"
                          color="inherit"
                        >
                          <Grid container>
                            <Grid item xs={9}>
                              <Typography variant="body1">
                                {row?.player?.firstName} {row?.player?.lastName}
                              </Typography>
                              <Typography
                                variant="caption"
                                paragraph
                                sx={{ mb: 0 }}
                              >
                                {row?.player?.army?.name ||
                                  row?.player?.armyName}
                              </Typography>
                              <Typography
                                variant="caption"
                                paragraph
                                sx={{ mb: 0 }}
                              >
                                {row?.player?.teamName}
                              </Typography>
                            </Grid>

                            <Grid item xs={3} textAlign="right">
                              {!row.event?.hidePlacings ? (
                                <>
                                  <Typography variant="body1">
                                    {t("wins", { keyPrefix: "misc.pairings" })}:{" "}
                                    {row?.player?.total_numWins ||
                                      row?.player?.numWins ||
                                      0}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    paragraph
                                    sx={{ mb: 0 }}
                                  >
                                    <>
                                      {row.player?.total_resultRecord
                                        ? row.player?.total_resultRecord?.map(
                                            (res, index) => {
                                              return (
                                                <>
                                                  {index > 0 && (
                                                    <span> / </span>
                                                  )}
                                                  <span
                                                    style={{
                                                      color:
                                                        res === 2
                                                          ? "green"
                                                          : res === 1
                                                            ? "blue"
                                                            : "red"
                                                    }}
                                                  >
                                                    {row.player?.total_record &&
                                                    row.player?.total_record[
                                                      index
                                                    ] !== undefined
                                                      ? row.player
                                                          ?.total_record[index]
                                                      : res}
                                                  </span>
                                                </>
                                              );
                                            }
                                          )
                                        : row.player?.resultRecord?.map(
                                            (res, index) => {
                                              return (
                                                <>
                                                  {index > 0 && (
                                                    <span> / </span>
                                                  )}
                                                  <span
                                                    style={{
                                                      color:
                                                        res === 2
                                                          ? "green"
                                                          : res === 1
                                                            ? "blue"
                                                            : "red"
                                                    }}
                                                  >
                                                    {row.player?.record &&
                                                    row.player?.record[
                                                      index
                                                    ] !== undefined
                                                      ? row.player?.record[
                                                          index
                                                        ]
                                                      : res}
                                                  </span>
                                                </>
                                              );
                                            }
                                          )}
                                    </>
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    paragraph
                                    sx={{ mb: 0 }}
                                  >
                                    {t("battlePoints", {
                                      keyPrefix: "misc.pairings"
                                    })}
                                    :{" "}
                                    {row?.player?.total_battlePoints ||
                                      row?.player?.battlePoints ||
                                      0}
                                  </Typography>
                                </>
                              ) : (
                                <Typography variant="caption">
                                  {t("placingsHidden", {
                                    keyPrefix: "misc.pairings"
                                  })}
                                </Typography>
                              )}
                            </Grid>
                          </Grid>
                        </Link>
                      </Grid>
                    </>
                  )
                }}
                loadMore={search}
                hasMore={hasMore}
                scrollToTop
              />
            </Grid>
          )}

          {shareModalOpen && (
            <ShareModal
              parentOpen={shareModalOpen}
              setParentOpen={setShareModalOpen}
              url={
                shareSearchPath
                  ? `${window.location.origin}${shareSearchPath}`
                  : window.location.href
              }
              linkOnly
            />
          )}
        </Grid>
      </Container>
      {(isSearching || !searchReady) && <ModalLoadingFull />}
    </Box>
  );
}
